export default __webpack_public_path__ + "static/contractor-supplier-banner-6d4d798667293ca7a6d52579fa8a48ed.png";